//innerStroke means blue stroke //outerStroke means grey stroke

<template>
  <div
    :class="page"
    style="
      height: 105%;
      width: 100.8%;
      overflow: hidden;
      position: absolute;
      top: -65px;
    "
    :style="opacity"
    class="svg-outer svg-topLayer img-laptop img-all"
    @click="reloadToggle"
  >
    <div class="arc-1" :style="arc1_setter">
      <arc1
        :stroke-color="arc1_color"
        :animate-speed="animationSpeed"
        :parent-clicked="reload"
      />
    </div>
    <div class="arc-2" :style="arc2_setter">
      <arc2
        :stroke-color="arc2_color"
        :animate-speed="animationSpeed"
        :parent-clicked="reload"
      />
    </div>
    <div class="arc-3" :style="arc3_setter">
      <arc3
        :stroke-color="arc3_color"
        :animate-speed="animationSpeed"
        :parent-clicked="reload"
      />
    </div>
    <div ref="circle_md" class="circle-1" :style="circle_md" />
    <div ref="circle_sm" class="circle-2" :style="circle_sm" />
    <div ref="circle_lg" class="circle-3" :style="circle_lg" />
    <div v-if="show || null" class="vehicle" :style="vehicle">
      <vehicle />
    </div>

    <div v-if="show || null" class="alert-icon" :style="alert_icon">
      <alerticon />
    </div>

    <div v-if="show || null" class="cone" :style="cone">
      <cone />
    </div>
  </div>
</template>

<script lang="ts">
import Arc1 from "./arc1.vue";
import Arc2 from "./arcMediumRotated.vue";
import Arc3 from "./arcBigRotated.vue";
import Vehicle from "./vehicle/vehicle.vue";
import AlertIcon from "@/components/prospect/brandPattern/other/alertIcon.vue";
import Cone from "@/components/prospect/brandPattern/other/cone.vue";
import { defineComponent } from "vue";
import $ from "jquery";
export default defineComponent({
  components: {
    arc1: Arc1,
    arc2: Arc2,
    arc3: Arc3,
    vehicle: Vehicle,
    alerticon: AlertIcon,
    cone: Cone,
  },
  props: {
    page: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      reload: true,
      show: true,
      animationSpeed: process.env.VUE_APP_BRANDPATTERN_SPEED
        ? parseInt(process.env.VUE_APP_BRANDPATTERN_SPEED)
        : 1500,
      arc1_color: "#387DFF",
      arc2_color: "#FFFFFF",
      arc3_color: "#FFFFFF",
      cicle_small_color: "#FFFFFF",
      circle_medium_color: "#FFFFFF",
      circle_large_color: "#FFFFFF",
      opacity_value: 1,
      arc1_setter: { top: "-48px", right: "0px" },
      arc2_setter: { top: "163px", left: "-15px" },
      arc3_setter: { top: "220px", right: "30px" },
      circle_sm_setter: {
        top: "430px",
        right: "0px",
        background: `${this.circle_small_color}`,
        "animation-duration": `${this.animationSpeed}ms`,
      },
      circle_md_setter: {
        top: "430px",
        right: "0px",
        background: `${this.circle_medium_color}`,
        "animation-duration": `${this.animationSpeed}ms`,
      },
      circle_lg_setter: {
        top: "430px",
        right: "0px",
        background: `${this.circle_large_color}`,
        "animation-duration": `${this.animationSpeed}ms`,
      },
      vehicle_setter: {},
      alert_setter: {},
      cone_setter: {},
    } as any;
  },
  computed: {
    opacity() {
      return {
        opacity: `${this.opacity_value}`,
      };
    },

    arc1Setter() {
      return this.arc1_setter;
    },
    arc2Setter() {
      return this.arc2_setter;
    },
    arc3Setter() {
      return this.arc3_setter;
    },

    circle_sm() {
      return this.circle_sm_setter;
    },
    circle_md() {
      return this.circle_md_setter;
    },
    circle_lg() {
      return this.circle_lg_setter;
    },
    vehicle() {
      return this.vehicle_setter;
    },
    alert_icon() {
      return this.alert_setter;
    },
    cone() {
      return this.cone_setter;
    },
  },
  created() {
    this.setChanges();
  },
  methods: {
    setChanges() {
      if (this.page == "LANDING") {
        this.arc1_color = "#FFFFFF";
        this.arc2_color = "#FFFFFF";
        this.arc3_color = "#FFFFFF";
        this.circle_small_color = "#FFFFFF";
        this.circle_medium_color = "#FFFFFF";
        this.circle_large_color = "#FFFFFF";
        this.opacity_value = 0.1;

        this.arc1_setter = { top: "-80px", right: "500px" };
        this.arc2_setter = { bottom: "130px", right: "90px" };
        this.arc3_setter = { bottom: "230px", left: "550px" };

        this.vehicle_setter = {
          right: "300px",
          top: "50%",
          transform: "translateY(-50%)",
        };
        this.alert_setter = { top: "150px", left: "700px" };
        this.cone_setter = { bottom: "150px", left: "100px" };

        this.circle_sm_setter = {
          top: "32%",
          left: "200px",

          background: `${this.circle_small_color}`,
          "animation-duration": `${this.animationSpeed}ms`,
        };
        this.circle_md_setter = {
          bottom: "22%",
          left: "50%",
          background: `${this.circle_medium_color}`,
          "animation-duration": `${this.animationSpeed}ms`,
        };
        this.circle_lg_setter = {
          top: "250px",
          right: "-75px",
          background: `${this.circle_large_color}`,
          "animation-duration": `${this.animationSpeed}ms`,
        };
      }
    },
    reloadToggle() {
      this.reload = !this.reload;
      this.show = false;
      $((this as any).$refs?.circle_md).removeClass("top-layer");
      $((this as any).$refs?.circle_sm).removeClass("top-layer");
      $((this as any).$refs?.circle_lg).removeClass("top-layer");
      setTimeout(() => {
        $((this as any).$refs?.circle_md).addClass("top-layer");
        $((this as any).$refs?.circle_sm).addClass("top-layer");
        $((this as any).$refs?.circle_lg).addClass("top-layer");
        this.show = true;
      }, 0);
    },
  },
});
</script>

<style scoped>
.arc-1 {
  position: absolute;

  height: 120px;
  z-index: 1;
}

.arc-2 {
  position: absolute;
  overflow: hidden;
  height: 300px;
  z-index: 1;
}

.arc-3 {
  position: absolute;
  z-index: 1;
  width: 327px;
  height: 400px;
}

.vehicle {
  position: absolute;
}

.svg-outer {
  position: absolute;
  overflow: hidden;

  top: -30px;
  left: 0%;
  zoom: 0.8;
}

.top-layer {
  animation-name: circle;
  animation-iteration-count: 1;
  animation-timing-function: linear;
}

.circle-1 {
  width: 60px;
  height: 60px;
  position: absolute;
  border-radius: 50%;
  z-index: 1;
  overflow: hidden;
  background: #48a0ff;
}

.circle-2 {
  width: 26px;
  height: 26px;
  position: absolute;
  border-radius: 50%;
  z-index: 1;
  overflow: hidden;
}

.circle-3 {
  width: 184px;
  height: 184px;
  position: absolute;
  border-radius: 50%;
  z-index: 1;
  overflow: hidden;
}

.alert-icon {
  position: absolute;
}

.cone {
  position: absolute;
}

@keyframes circle {
  from {
    opacity: 0%;
  }

  to {
    opacity: 100%;
  }
}

@media screen and (min-width: 3840px) {
  .svg-outer {
    zoom: 2 !important;
  }
}

/*
@media screen and (min-width: 2000px) and (max-width: 3839px), not screen and (min-height:1100) {
  .svg-outer{
    zoom: 1.9 !important;
  }

}

@media screen and (min-width: 2000px) and ( orientation: potrait ) {
  .svg-outer {
    zoom: 1.4 !important;
  }

}*/

@media only screen and (max-width: 3440px) {
  .svg-outer {
    zoom: 1;
  }
}

@media only screen and (max-width: 2560px) {
  .svg-outer {
    zoom: 1.8;
  }
}

@media only screen and (max-width: 2048px) {
  .svg-outer {
    zoom: 1.4;
  }
}

@media only screen and (max-width: 1680px) {
  .svg-outer {
    zoom: 1;
  }
}

@media only screen and (max-width: 1600px) {
  .svg-outer {
    zoom: 1.1;
  }
}

@media only screen and (max-width: 1366px) {
  .svg-outer {
    zoom: 1;
  }
  .arc-1 {
    right: 355px !important;
  }

  .arc-2 {
    top: unset !important;
    bottom: 130px !important;
    left: unset !important;
    right: 50px !important;
  }

  .arc-3 {
    left: 500px !important;
    bottom: 250px !important;
  }
  .circle-2 {
    top: 15% !important;
    left: 41% !important;
  }
  .circle-1 {
    left: unset !important;
    right: 500px !important;
    bottom: 250px !important;
  }
  .alert-icon {
    top: 200px !important;
    left: 300px !important;
  }

  .vehicle {
    top: unset !important;
    bottom: 300px !important;
    left: unset !important;
    right: 70px !important;
  }
  .cone {
    top: unset !important;
    bottom: 150px !important;
    left: unset !important;
    left: 70px !important;
  }
}

/*@media only screen and (max-width: 1024px) {
  .svg-outer{
    zoom: 1.2 ;
  }
  .arc-1{
    right:0px;
  }

  .arc-2{
    top:500px;
    left:20px;
  }

  .arc-3{
    right: 30px;
    top: 775px;
  }
  .circle-2{
    left: 290px;
  }
  .circle-1{
    right: 0px;
  }
}*/

@media only screen and (min-width: 768px) and (max-width: 1024px) {
  .svg-outer {
    zoom: 0.9;
  }
  .arc-1 {
    bottom: 100px !important;
    right: 200px !important;
  }

  .arc-2 {
    top: unset !important;
    bottom: 100px !important;
    left: unset !important;
    right: 50px !important;
  }

  .arc-3 {
    top: unset !important;
    bottom: 230px !important;
    left: unset !important;
    right: 370px !important;
  }

  .circle-1 {
    bottom: 200px !important;
    right: 400px !important;
  }
  .circle-2 {
    left: 180px !important;
    top: 40% !important;
    transform: translateY(-50%);
  }

  .circle-3 {
    bottom: -50px !important;
  }
  .alert-icon {
    top: 200px !important;
    left: 300px !important;
  }

  .vehicle {
    top: unset !important;
    bottom: 300px !important;
    left: unset !important;
    right: 70px !important;
  }
  .cone {
    top: unset !important;
    bottom: 350px !important;
    left: unset !important;
    left: 70px !important;
  }
}

@media only screen and (max-device-width: 812px) {
  .svg-outer {
    display: none !important;
  }
}
</style>
